import { fetcher } from '../fetcher';
import { clientsSchema, clientSchema } from '../schemas';
import type { ClientProps } from '../types';

export const clientsService = {
  getClients: () => {
    return fetcher(
      `/clients/all
       ?with[]=owner
      `.replace(/\s+/g, ''),
      {
        method: 'GET',
        schema: clientsSchema,
      }
    );
  },
  saveClient: (client: ClientProps) => {
    return fetcher(`/clients/import`, {
      method: 'POST',
      schema: clientSchema,
      body: client,
    });
  },
  destroyClient: (id: number) => {
    return fetcher(`/clients/${id}`, {
      method: 'DELETE',
    });
  },
};
